var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-button',{staticClass:"mb-2",attrs:{"type":"primary"},on:{"click":_vm.hanleCreate}},[_vm._v(_vm._s(_vm.$t('scope.text_58')))]),_c('ceph-list',{attrs:{"list":_vm.lists.rbd,"manager":_vm.manager,"refresh":_vm.queryStorageList}}),_c('nfc-list',{attrs:{"list":_vm.lists.nfs,"manager":_vm.manager,"refresh":_vm.queryStorageList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }